import axios from "axios";
import * as ActionType from "./role.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

// Get Roles
export const getRoles = (page, limit) => (dispatch) => {
  apiInstanceFetch
    .get(`role/compileRoleIndex?start=${page}&limit=${limit}`)
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.GET_ROLES,
          payload: { data: res.data, total: res.total },
        });
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to fetch roles.");
    });
};

// Create Role
export const createRole = (data) => (dispatch) => {
  return axios
    .post("role/craftRole", data , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.CREATE_ROLE, payload: res.data.data }); // adjust based on actual API return
        setToast("success", "Role created successfully.");
        return { status: true };
      } else {
        setToast("error", res.data.message);
        return { status: false };
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to create role.");
      return { status: false };
    });
};

// Edit Role
export const editRole = (roleId, data) => (dispatch) => {
  return axios
    .patch("role/realignRole", { roleId, ...data } , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.EDIT_ROLE, payload: res.data.data }); 
        setToast("success", "Role updated successfully.");
        return { status: true };
      } else {
        setToast("error", res.data.message);
        return { status: false };
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to update role.");
      return { status: false };
    });
};

// Toggle Role Status
export const toggleRoleStatus = (roleId) => (dispatch) => {
 return apiInstanceFetch
    .patch(`role/switchRoleAvailability?roleId=${roleId}`)
    .then((res) => {
      if (res?.status) {
        dispatch({ type: ActionType.UPDATE_ROLE_STATUS, payload: roleId });
        setToast("success", res?.message);
      } else {
        setToast("error", res?.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to toggle role status.");
    });
};

// Delete Role
export const deleteRole = (roleId) => (dispatch) => {
  axios
    .delete(`role/archiveRole?roleId=${roleId}` , {
      headers: {
        "Authorization": `${sessionStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_ROLE, payload: roleId });
        setToast("success", "Role deleted successfully.");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", "Failed to delete role.");
    });
};

// Get Eligible Roles
export const getEligibleRoles = () => (dispatch) => {
  apiInstanceFetch
    .get("role/collectEligibleRoles")
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.GET_ELIGIBLE_ROLES,
          payload: res.data,
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
